
    const data = {"name":"src/core/icons/calendar-range","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M9 10H7v2h2v-2m4 0h-2v2h2v-2m4 0h-2v2h2v-2m2-7h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V8h14v11Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            